import { nextResumeDate } from '../lib/season.js';

export function ClosedScreen() {
  const resume = nextResumeDate();
  const [year, month, day] = resume.split('-');
  return (
    <div className="flex min-h-full flex-col items-center justify-center bg-slate-50 pt-safe pb-safe px-6 text-center">
      <div className="text-6xl">❄️</div>
      <h1 className="mt-6 text-2xl font-semibold text-slate-800">サービス停止中</h1>
      <p className="mt-3 text-slate-600">
        熱中症マップは{' '}
        <span className="font-semibold">{year}年{Number(month)}月{Number(day)}日</span>{' '}
        から再開します。
      </p>
      <p className="mt-2 text-sm text-slate-500">
        環境省 熱中症予防情報サイトの配信期間（4月22日〜10月21日）に合わせています。
      </p>
      <p className="mt-8 text-xs text-slate-400">
        出典：環境省熱中症予防情報サイト ／ 気象庁ホームページ
      </p>
    </div>
  );
}
